/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { apiFetch } from '../../../apiClient';
import paths from '../../../config/path';
import history from '../../../utils/history';
import { isStringEmpty, setTitle } from '../../../utils';
import { apiMap } from '../../../config/constants';
import { getAccountMessage, saveQuestionsForm } from '../state/action';
import BasePage from '../../../shared/BasePage';
import AOForm from '../../../shared/AOForm';
import FormTitle from '../../../shared/AOForm/components/FormTitle';
import StepIndicator from '../../../shared/StepIndicator';
import AccountQuestionForm from '../components/AccountQuestionForm';
import { findQuestionById } from '../../../utils/AOFormUtils';
import { updateStep } from '../../CompanyRegistration/state/action';
import './style.css'
/* eslint-disable array-callback-return */
class Question extends BasePage {
    constructor(props) {
        super(props);
        this.state = {
            isShowError: false,
            errorList: [],
            errorMsgs: {},
            isApplicable: false
        }
        this.isYesNo = {
            'Q002-002': false,
            'Q002-003': false
        }
        // 如果选了这些，就默认“是”
        this.mapDataId = {
            '2': ['001:012,002:004'], // 请问贵公司或母公司是否金融机构
            '3': ['001:011,002:004,003:006', '001:002,002:002,003:005', '001:002,002:002,003:004'], // 公司或其客户／供应商是否涉及博彩业（如：网上赌博、赌场）或 军事／国防行业
        };
        this.isQuestionStatus = true;
    }
    // setMapId = (total, firstId) => {
    //     let arrays = [firstId];
    //     const zero = firstId.substring(0,1) === '0' ? '0' : '';
    //     for (let i=1; i<total; i++) {
    //         firstId = parseInt(firstId, 10) + 1;
    //         arrays.push(`${zero}${firstId}`);
            
    //     };
    //     return arrays;
    // }
    componentDidMount = () => {
        this.handleApplicationInfo(this.props);
        this.switchI18n();
        
    }
    componentWillReceiveProps = (nextProps) => {
        this.handleApplicationInfo(nextProps);
        if (nextProps.selectedLanguage !== this.props.selectedLanguage) {
            this.switchI18n();
        }
    }

    handleApplicationInfo = ({applicationInfo, businessInfo}) => {
        if (applicationInfo) {
            const channelId = applicationInfo.channelId;
            const currentSection = findQuestionById(applicationInfo, 'S002');
            const S001 = findQuestionById(applicationInfo, 'S001');
            const businessType = S001.questions[1].subQuestions[1] && S001.questions[1].subQuestions[1].userAnswer && S001.questions[1].subQuestions[1].userAnswer.chosenAnswerId;
            const isApplicable = (businessType === 'A001-002-002:001' || businessType === 'A001-002-002:002');
            if (currentSection && businessInfo) {
                const { questions } = currentSection;
                const userAnswer = businessInfo.answerDetails || {};
                const questionStatus = businessInfo.questionStatus || {};
                if (questionStatus.companyType === '2') 
                    this.isQuestionStatus = false;
                questions.map(item => {
                    const { questionId } = item;
                    item.answers.map(answer => {
                        if (item.userAnswer && userAnswer[item.questionIndicator] === answer.answerIndicator) {
                            item.userAnswer.chosenAnswerId = answer.answerId;
                        }
                    });
                    if (!item.userAnswer) {
                        item.userAnswer = {
                            chosenAnswerId: ''
                        };
                    } else if (channelId !== "ePort" && isApplicable && (questionId === 'Q002-001' || questionId === 'Q002-002' || questionId === 'Q002-005')) {
                        if (questionId === 'Q002-001') {
                            item.userAnswer.chosenAnswerId = `${questionId.replace('Q', 'A')}:001`;
                        } else {
                            item.userAnswer.chosenAnswerId = `${questionId.replace('Q', 'A')}:002`;
                        }
                    }
                });
                
                //选择basic的行业性质,赋默认值给002\003
                if (this.isQuestionStatus && channelId !== "ePort") {
                    const subQuestionS001 = S001.questions[2].subQuestions || [];
                    subQuestionS001.map((subQuestionStep1, index) => {
                        const answerTmp = [];
                        subQuestionStep1 && subQuestionStep1.subQuestions.map((item, index) => {
                            const IndustryAnswerId = item.userAnswer && item.userAnswer.chosenAnswerId;
                            const answerNum = IndustryAnswerId ? IndustryAnswerId.split('-')[3] : null;
                            answerNum && answerTmp.push(answerNum);
                        });
                        Object.keys(this.mapDataId).forEach(key => {
                            this.mapDataId[key].forEach(id => {
                                if (answerTmp.length > 0 && (answerTmp.join(',').indexOf(id) > -1)) {
                                    this.isYesNo[`Q002-00${key}`] = true;
                                    questions[key - 1] && (questions[key - 1].userAnswer = { chosenAnswerId: `A002-00${key}:001` });
                                }
                            })
                         });
                    });
                    !this.isYesNo['Q002-002'] && questions[1] && questions[1].questionIndicator === 'finanIns' && (questions[1].userAnswer = { chosenAnswerId: 'A002-002:002' });
                    !this.isYesNo['Q002-003'] && questions[2] && questions[2].questionIndicator === 'gamingIndus' && (questions[2].userAnswer = { chosenAnswerId: 'A002-003:002' });
                }
                this.setState({
                    currentSection,
                    isApplicable
                })
            }
        }
    }
    switchI18n = () => {
        apiFetch(apiMap.accountI18n, {})().then( i18n => {
            this.props.getAccountMessage({ i18n });
        }).catch(error => {});
    }

    answerHandleChange = (questionRel, value) => {
        const { currentSection, errorList } = this.state;
        const itemIndex = errorList.indexOf(questionRel.questionId);
        if (itemIndex !== -1) {
            errorList.splice(itemIndex, 1);
        }
        switch (questionRel.answerType) {
            case 1:
                questionRel.userAnswer = { chosenAnswerId: value };
                break;
            default:
                break;
        }
        this.setState({
            currentSection
        });
    }
    onChangeNextSubmit = () => {
        const { saveQuestionsForm, businessInfo } = this.props;
        const { questions } = this.state.currentSection;
        let dataTmp = {};
        this.validatePQForm()
        .then(()=> {
            questions.map(item => {
                item.answers.map(answer => {
                    if (item.userAnswer && (item.userAnswer.chosenAnswerId === answer.answerId)) {
                        item.userAnswer.chosenAnswerId = answer.answerIndicator;
                    }
                })
                const questionIndicator = item.questionIndicator;
                dataTmp[questionIndicator] = item.userAnswer.chosenAnswerId;
            });
            businessInfo.answerDetails = {
                ...businessInfo.answerDetails,
                ...dataTmp
            };
            businessInfo.questionStatus = {
                ...businessInfo.questionStatus,
                "companyType": '2'
            }
            return saveQuestionsForm({
                "answerDetails": dataTmp,
                "questionStatus": {
                    "companyType": '2'
                }
            });
        }).then((resp)=>{
            this.props.updateStep({"progressIndex": 3, "status": 1});
            history.push(paths.previewQuestion.path);
        }).catch(error => {
            this.setState({
                isShowError: true
            });
            this.scrollToTop();
        })
        
    }
    validatePQForm = () => {
         return new Promise((resolve, reject) => {
            const { currentSection, errorList } = this.state;
            const questions = currentSection.questions;
            questions && questions.forEach((question)=> {
                this.checkUserAnswer(question, errorList)        
            })
            this.setState({
                errorList: errorList
            }, () => {
                const { errorList } = this.state;
                if (errorList && errorList.length > 0) {
                    reject && reject(errorList)
                } else {
                    resolve && resolve()
                }
            });
        });
    }
    checkUserAnswer = (question, errorList) => {
        const {errorMsgs} = this.state;
        const {
            questionId,
            userAnswer,
            answerType
        } = question;
        let tempUserAnswer = null;
        let requireErrorMsg = this.props.i18n.requireMsg;
        const removeFormErrorList = (errorList, index) => {
            if (index !== -1) {
                errorList.splice(index, 1);
            }
        }
        const addError = (errorList, index, errorItem) => {
            if (index === -1) {
                errorList.push(errorItem);
            }
        }
        switch (answerType) {
            case 1:
                tempUserAnswer = userAnswer && userAnswer.chosenAnswerId
                break;
            default:
                break;
        }
        const itemIndex = errorList.indexOf(questionId);
        if (isStringEmpty(tempUserAnswer)) {
            addError(errorList, itemIndex, questionId);
            errorMsgs[questionId] = requireErrorMsg
        } else { 
             removeFormErrorList(errorList, itemIndex);                 
        }
    }
    backAction = () => {
        history.push(paths.basicInfo.path);
    }
    render() {
        const { i18n, selectedLanguage, appMessages, pageTitle } = this.props;
        const { currentSection, isShowError, errorList, errorMsgs, isApplicable } = this.state;

      if (i18n && pageTitle) {
        setTitle( i18n.title + pageTitle);
      }

        return (i18n && currentSection) ? (
            <div className="dynamic-form ao-form container pq-form account-step">
                <StepIndicator currentStep={4} stepInfo={appMessages.stepInfo} stepTitle={appMessages.stepTitle} />
                <FormTitle content={{
                    title: {
                        text: i18n.title,
                        dataKey: 'account-title'
                    },
                    subTitle: {
                        text: i18n.tip,
                        dataKey: 'account-subTitle'
                    },
                    optional_msg: { text: appMessages.form_base_content.optional_msg, dataKey: "optional_msg"}
                }}
                errorAtTop = {{
                    content: appMessages.form_base_content.form_error_prompt,
                    isDisplay: isShowError
                }}
                />
                <div className="account-container">
                    <AccountQuestionForm
                        dataId={'account-questionForm-form'}
                        formResult={currentSection}
                        isApplicable={isApplicable}
                        i18n={i18n}
                        errorList={errorList}
                        errorMsgs={errorMsgs}
                        isYesNo={this.isYesNo}
                        isQuestionStatus={this.isQuestionStatus}
                        selectedLanguage={selectedLanguage}
                        onChangeAnswerForm={this.answerHandleChange} />
                </div>
                <AOForm.BottomButtonsGroup
                    saveButtonShow = {false}
                    content={appMessages.form_base_content.bottomButtonsContent}
                    backAction={this.backAction}
                    completeFormAction={this.onChangeNextSubmit}
                />
            </div>
        ) : null
    }
}

Question.propTypes = {
    i18n: PropTypes.object,
    selectedLanguage: PropTypes.string
};

const mapStateToProps = (state) => ({
    applicationInfo: state.app.applicationInfo,
    i18n: state.accountQuestion.i18n,
    selectedLanguage: state.app.selectedLanguage,
    businessInfo: state.app.businessInfo,
    appMessages: state.app.i18n,
    pageTitle: state.app.i18n.pageTitle
});

export default connect(mapStateToProps, {
    updateStep,
    getAccountMessage,
    saveQuestionsForm
})(Question);


// WEBPACK FOOTER //
// ./src/views/AccountQuestion/container/AccountQuestion.js